import { useCallback } from 'react'

import { AiCreditsQueryDocument, FactorialOneLayoutQuery } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useLazyQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

export const useAiChatCreditsUsage = (
  companyId: string,
  currentCompany: FactorialOneLayoutQuery['apiCore']['companiesConnection']['nodes'][0] | undefined
) => {
  const { navigation } = useNavigation()
  const [fetchCredits] = useLazyQuery(AiCreditsQueryDocument)

  const fetchUsage = useCallback(async () => {
    const result = await fetchCredits({ variables: { companyId } })
    const remaining =
      result.data?.aiCredits.creditStatusesConnection.nodes[0]?.remainingCredits ?? 0
    const total = 500
    return { used: total - remaining, total }
  }, [fetchCredits, companyId])

  return {
    fetchUsage,
    companyName: currentCompany?.name,
    companyLogoUrl: (currentCompany?.workspaceLogo || currentCompany?.logo) ?? undefined,
    planName: i18n.t('common.ai.credits.free_plan'),
    upgradePlanUrl:
      navigation.discover.marketplaceModules.item.fullPath({ id: 'one' }) +
      '?action=init-self-upsell',
  }
}
